import restJson from '../../assets/Rutas.json'

export const toggleSidebarDesktop = (state) => {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
}
export const toggleSidebarMobile = (state) => {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
}
export const set = (state, [variable, value]) => {
    state[variable] = value
}
export const setToken = (state, payload) => {
    state.token = payload
}
export const loginStart = (state) => { state.loggingIn = true }
export const loginStop = (state, errorMessage) => {
    state.loggingIn = false;
    state.loginError = errorMessage;
    state.loginSuccessful = !errorMessage;
}
export const getRutas = (state, payload) => {
    var servicio = restJson.filter(ruta => ruta.metodo == payload.metodo)

    if (servicio[0].parametros == "") {
        state.config = {
            method: servicio[0].tipo,
            url: servicio[0].ruta,
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': servicio[0].XAPPID,
                'Authorization': 'Bearer ' + state.token
            },
            data: payload.data == "" ? '' : JSON.stringify(payload.data)
            
            
        }
    } else {
        
        state.config = {
            method: servicio[0].tipo,
            url: servicio[0].ruta + "?" + payload.data,
            headers: {
                'Content-Type': 'application/json',
                'XAPPID': servicio[0].XAPPID,
                'Authorization': 'Bearer ' + state.token
            }

        }
    }
}
export const setDataResponse = (state, payload) => {
    state.dataResponse = payload;
}
export const setDataRaw = (state, payload) => {
    state.dataRaw = payload;
}
export const setErrorMessage = (state, payload) => {
    state.errorMessage = payload;
}
export const setLimpiadataResponse = (state) => {
    state.dataResponse = ''
}
export const showModal = (state, payload) => {
    state.showModal = payload.muestra
    if (payload.muestra) {
        state.configModal.color = payload.color
        state.configModal.contenido = payload.contenido
        state.configModal.boton = payload.boton
        state.configModal.titulo = payload.titulo

    }
}
export const showLoading = (state) => {
    state.Loading = !state.Loading
}

export const hideLoading = (state) => {
    state.Loading = false;
}
export const setFlagResponse = (state, payload) => {
    state.flagResponse = payload;
}
export const cargaimgEmpleado = (state, payload) => {
    //Y:/2021/avatars/
    state.imgEmpleado = '//192.168.10.208/Sistemas-PMO/2021/avatars/' + payload;
}
export const setDataEndosos = (state, payload) => {
    state.dataEndosos = payload;
}
export const setCatLineas = (state, payload) => {
    state.catLineas = payload;
}
export const setMaxRenglones = (state, payload) => {
    state.maxRenglones = payload;
}
export const setDatosEndosoCreado = (state, payload) => {
    state.datosEndosoCreado = payload;
};
  
